module.exports = __webpack_public_path__ + "static/media/simplonbp-regular-webfont.b872e37f.ttf";